import { Component, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ModalDialog } from '../../../../shared/modal-dialog';
import { State, Group } from '../../../model/eform-type';
import { GroupListComponent } from '../../../dialog/group-list/group-list.component';
import { EFormHelper } from '../../../helper/script/helper';
import { TranslateService } from '@ngx-translate/core';
@Component({
   selector: 'app-section-properties',
   templateUrl: './section-properties.component.html',
   styleUrls: ['./section-properties.component.scss']
})
export class SectionProPertiesComponent {
   @Input() eForm: FormGroup;
   @Input() state: State;
   @Output() sendFocus = new EventEmitter<boolean>();
   showViewPermission: boolean = false; //ทำการ Hide ในส่วนของการ Set Permission ไว้ก่อน ไว้ขึ้น Phase ||
   helper = new EFormHelper();
   constructor(private dialog: ModalDialog, private fb: FormBuilder, public translate: TranslateService) { }

   get section() {
      return this.helper.getSectionAsFormGroupWithIndex(this.eForm, this.state.sectionIndex);
   }

   get permission() {
      return this.helper.getPermission(this.eForm, this.state.sectionIndex);
   }

   openGroupList(authority: string) {
      const data = this.helper.getPermissionValue(this.eForm, this.state.sectionIndex);
      const _dialog =  this.dialog.open(GroupListComponent, { data }, result => {
         if (result) {
            this.setPermission(result, authority);
         }
      });
      _dialog.afterOpened().subscribe(() => {
         this.sendFocusToCreate(false);
      });
      _dialog.afterClosed().subscribe(() => {
         this.sendFocusToCreate(true);
      });
   }

   setPermission(result: Group[], authority: string) {
      result.forEach((item: Group) => {
         item.type = 'GROUP';
         item.authority = authority;
         this.permission.push(this.fb.group(item));
      });
      const _index = this.permission.value.findIndex((v: Group) => v.authority === authority && v.name === 'Everyone');
      if (_index !== -1) {
         this.permission.removeAt(_index);
      }
      this.permission.patchValue(this.permission.value.sort((x: Group, y: Group) => x.name.localeCompare(y.name)));
   }

   removePermission(index: number, authority: string) {
      this.permission.removeAt(index);
      const _value: Group[] = this.permission.value.filter((v: Group) => v.authority === authority);
      if (_value.length === 0) {
         this.permission.push(this.fb.group({ type: 'GROUP', id: 'Everyone', name: 'Everyone', groupCode: 'Everyone', siteCode: 'Everyone', authority: authority }));
      }
   }

   sendFocusToCreate(focus: boolean) {
      this.sendFocus.emit(focus);
   }

}
